import React from "react";

import "./ContentUnavailable.css";

type ContentUnavailableProps = {
  title?: string;
  message?: string;
};

const ContentUnavailable: React.FC<ContentUnavailableProps> = ({
  title = "Страница недоступна",
  message = "Похоже, эта страница сейчас не отвечает или была удалена. Попробуйте зайти позже.",
}) => (
  <div className="content-unavailable">
    <span
      className="content-unavailable__icon"
      aria-hidden="true"
    >
      ⚠
    </span>
    <h2 className="content-unavailable__title">{title}</h2>
    <p className="content-unavailable__message">{message}</p>
  </div>
);

export default ContentUnavailable;
